const optionsList = ['disableOptimalOrderHeuristic', 'build'];
export const applyOptionsList = optionsList;
export const revertOptionsList = optionsList;
